import { render, staticRenderFns } from "./DataTableComponent.vue?vue&type=template&id=6f0e245d&"
import script from "./DataTableComponent.vue?vue&type=script&lang=js&"
export * from "./DataTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports